import { UseFormReturn } from "react-hook-form";
import SearchAddressForm from "@shared/components/application/form/search-address/SearchAddressForm/SearchAddressForm.web";
import { useEffect } from "react";
import { useTranslation } from "@shared/utils/internationalization";
import { AddressType } from "@shared/components/application/form/search-address/SearchAddressForm/SearchAddressForm.props";

export const FORM_ID = "checkout_billing_address_form";

export default function CheckoutBillingAddressForm({
  form,
  id = FORM_ID,
  onValidFields,
  onInvalidFields,
  onBillingAddressChange,
}: {
  form: UseFormReturn;
  id?: string;
  onValidFields?: () => void;
  onInvalidFields?: () => void;
  onBillingAddressChange?: (billingAddress: AddressType) => void;
}) {
  const { t } = useTranslation("common");

  useEffect(() => {
    if (form.formState.isValid) {
      onValidFields?.();
    } else {
      onInvalidFields?.();
    }
  }, [form.formState.isValid]);

  return (
    <form data-testid={id} id={id} onSubmit={(e) => e.preventDefault()}>
      <SearchAddressForm
        searchAriaLabel={t("Billing address")}
        label={t("Billing address")}
        form={form}
        formId={id}
        isRequired
        titleProps={{
          fontWeight: 700,
          marginBottom: "6px",
        }}
        updateAddressCallback={onBillingAddressChange}
      />
    </form>
  );
}
